import { useDispatch, useSelector } from "react-redux";
import { siteGallerySelector, getSiteGallery } from "../siteGallerySlice";
import React from 'react'
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";


export const useSiteGallery = ({small, large}) => {

    const isSmallScreen = useIsSmallScreen();

    const dispatch = useDispatch();

    const [pageSize, setPageSize] = React.useState(large);

    const [pageAmount, setPageAmount] = React.useState(1);

    const [currentPage, setCurrentPage] = React.useState(1);

    const countGallery = useSelector(x => x.site.siteGallery.count);

    React.useEffect( () => {
        setCurrentPage(1);
        setPageSize(isSmallScreen ? small : large);

    }, [isSmallScreen, small, large])

    React.useEffect( () => {
        dispatch(getSiteGallery({page: currentPage, page_size: pageSize}));
        setPageAmount(Math.ceil(countGallery / pageSize));
    }, [dispatch, currentPage, pageSize, countGallery])

    const siteGallery = useSelector(siteGallerySelector.selectAll);
    const siteGalleryIsLoading = useSelector(x => x.site.siteGallery.isLoading);

    return [siteGallery, siteGalleryIsLoading, currentPage, setCurrentPage, pageAmount]
}
